import React, { useState } from 'react';
import { Button, Alert, Card } from 'react-bootstrap';
import { supabase } from '../utils/supabase/client';

const CreateAdminUser = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [createdUsers, setCreatedUsers] = useState([]);

  const adminUsers = [
    { email: 'gutopc@gmail.com', password: '@RaviMori147' },
    { email: 'vinicius@ravi.com.br', password: '@RaviMori147' },
    { email: 'cotacao@ravi.com.br', password: '@RaviMori147' }
  ];

  const createAdmins = async () => {
    setLoading(true);
    setMessage('');
    setError('');
    const results = [];

    for (const admin of adminUsers) {
      const { error } = await supabase.auth.signUp({
        email: admin.email,
        password: admin.password
      });

      if (error) {
        results.push({ email: admin.email, status: `Erro: ${error.message}` });
      } else {
        results.push({ email: admin.email, status: 'Criado com sucesso' });
      }
    }

    setCreatedUsers(results);
    setMessage('Processo concluído. Verifique os emails no Supabase Dashboard.');
    setLoading(false);
  };

  return (
    <div className="container mt-5">
      <Card>
        <Card.Header><h4>Criar Usuários Admin (Supabase)</h4></Card.Header>
        <Card.Body>
          <p>Cria os usuários admin no Supabase Auth.</p>
          {message && <Alert variant="success">{message}</Alert>}
          {error && <Alert variant="danger">{error}</Alert>}
          {createdUsers.length > 0 && (
            <ul>
              {createdUsers.map((u, i) => (
                <li key={i}>{u.email}: {u.status}</li>
              ))}
            </ul>
          )}
          <Button onClick={createAdmins} disabled={loading}>
            {loading ? 'Criando...' : 'Criar Usuários Admin'}
          </Button>
        </Card.Body>
      </Card>
    </div>
  );
};

export default CreateAdminUser;
